import React, { useState, useEffect } from "react"
import ReactPlayer from "react-player"
import { graphql } from "gatsby"

export const query = graphql`
  fragment VideoFields on DatoCmsVideo {
    model {
      apiKey
    }
    id
    componentId: key
    image {
      url(imgixParams: { w: "1400" })
    }
    headline
    preserveAspectRatio
    video {
      video {
        high: mp4Url(res: high)
        medium: mp4Url(res: medium)
        low: mp4Url(res: low)
        streamingUrl
      }
    }
  }
`

export interface VideoProps extends Queries.VideoFieldsFragment {
  showHeadline?: boolean
  inline?: boolean
  playing?: boolean
}

const Video = (props: VideoProps) => {
  if (!props.video) {
    return null
  }
  const imgSrc = props.image && props.image.url
  const video = props.video.video
  const preserveAspectRatio = props.preserveAspectRatio
    ? props.preserveAspectRatio
    : false
  const playing = typeof props.playing === "undefined" ? true : props.playing
  const showHeadline =
    typeof props.showHeadline === "undefined" ? true : props.showHeadline
  const inline = typeof props.inline === "undefined" ? false : props.inline
  const [hasWindow, setHasWindow] = useState<boolean>(false)

  useEffect(() => {
    // Needed to fix a hydration error
    // See https://github.com/cookpete/react-player/issues/1428
    if (typeof window !== "undefined") {
      setHasWindow(true)
    }
  }, [])

  return (
    <section
      id={props.componentId}
      className={`c-video ${preserveAspectRatio ? "-contain" : ""}`}
    >
      {props.headline && showHeadline && (
        <h2 className="c-content-header">{props.headline}</h2>
      )}
      <div
        className={`u-flex u-space-evenly ${!inline ? "o-wrapper o-row" : ""}`}
      >
        <div className="c-video__wrapper">
          {hasWindow && (
            <ReactPlayer
              url={video.streamingUrl || video.high}
              playIcon={<button className="play"></button>}
              light={imgSrc}
              playing={playing}
              width="100%"
              height="100%"
              controls={true}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default Video
